module.exports = __webpack_public_path__ + "media/80_Long.c748c1f9.mp3";